import { render, staticRenderFns } from "./FlexiShuttleDashboardUs.vue?vue&type=template&id=62046736&scoped=true"
import script from "./FlexiShuttleDashboardUs.vue?vue&type=script&lang=js"
export * from "./FlexiShuttleDashboardUs.vue?vue&type=script&lang=js"
import style0 from "./FlexiShuttleDashboardUs.vue?vue&type=style&index=0&id=62046736&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62046736",
  null
  
)

export default component.exports